import { getRegressionModelWarnings } from '@aloft/toolkit-shared';
import { Flex, Icon, Typography, colors } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/no-direct-chakra, aloft/prefer-sound-ui-button, import/no-extraneous-dependencies
import {
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';

import { selectRegression } from '../../../redux/features/selectors/unitRatesSelectors/selectUnitRates.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { RegressionModalFeatureTable } from './RegressionModalFeatureTable.tsx';
import { RegressionModalGraphSection } from './RegressionModalGraphSection.tsx';
import { StatsRow } from './StatsRow.tsx';

export const RegressionAnalysisModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const regression = useAppSelector(selectRegression);
  const output = regression?.status === 'success' ? regression.output : undefined;
  const regressionModelWarnings = getRegressionModelWarnings(regression);

  return (
    <ChakraModal isOpen={isOpen} onClose={onClose} scrollBehavior="inside" size="6xl" isCentered>
      <ModalOverlay />
      <ModalContent bg={colors.surface3} onKeyDown={(e) => e.stopPropagation()}>
        <ModalCloseButton />
        <ModalBody padding="1.5rem">
          <Flex flexDirection="column" gap="1rem">
            <Flex alignItems="center" gap="0.75rem">
              <Icon icon="line-chart" size="xl" />
              <Typography variant="h1">Regression Analysis Model</Typography>
            </Flex>

            <Typography
              variant="body2"
              color="textSecondary"
              __dangerDoNotUseSx={{ maxWidth: 'none' }}
            >
              Toolkit&apos;s regression model is built using a sample of the 150 most proximate
              properties to the Subject that sold within the past 12 months.
            </Typography>
            {regressionModelWarnings
              .filter(
                (warning) =>
                  warning.warning !== null && ['UNRELIABLE', 'WEAK'].includes(warning.label),
              )
              .map((warning) => (
                <Flex key={warning.warning} alignItems="center" gap="0.5rem">
                  <Icon
                    icon="error-warning"
                    size="sm"
                    color={warning.label === 'UNRELIABLE' ? 'textError' : 'textWarning'}
                  />
                  <Typography variant="tableH1" color="textPrimary">
                    {warning.warning!}
                  </Typography>
                </Flex>
              ))}

            {output && (
              <>
                <StatsRow type="regression" output={output} />
                <RegressionModalFeatureTable regression={regression} />
                <RegressionModalGraphSection output={output} />
              </>
            )}
          </Flex>
        </ModalBody>
      </ModalContent>
    </ChakraModal>
  );
};
